import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67f37ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "contentinfo",
  class: "full"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "sr-only" }, "Footer links", -1))
const _hoisted_3 = { class: "footer--content" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = { class: "links" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Information", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Customer Support")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Resell Your Ticket")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Ticket Your Event")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("About Oztix")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Terms & Conditions")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Privacy")
const _hoisted_13 = { class: "social" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Follow us", -1))
const _hoisted_15 = {
  href: "https://www.facebook.com/Oztix/",
  title: "Oztix Facebook Page",
  target: "_blank"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Facebook")
const _hoisted_17 = {
  href: "https://twitter.com/oztix",
  title: "Oztix on Twitter",
  target: "_blank"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Twitter")
const _hoisted_19 = {
  href: "https://www.instagram.com/oztix/",
  title: "Oztix on Instagram",
  target: "_blank"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Instagram")
const _hoisted_21 = {
  href: "https://www.linkedin.com/company/oztix",
  title: "Oztix LinkedIn Company Page",
  target: "_blank"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" LinkedIn")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oztix_logo = _resolveComponent("oztix-logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_copyright = _resolveComponent("copyright")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_oztix_logo)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/customer-support" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/resell-your-ticket" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/ticket-your-event",
              onClick: _ctx.ticketYourEventClick
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/about" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/terms-and-conditions" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/privacy" }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_15, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'facebook'] }),
              _hoisted_16
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_17, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'twitter'] }),
              _hoisted_18
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_19, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'instagram'] }),
              _hoisted_20
            ])
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_21, [
              _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin'] }),
              _hoisted_22
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_copyright)
  ]))
}